<div class="subBlockContainer">
  <child-header title="New Delivery Location" (closeEvent)="close()"></child-header>
  <div class="subBlockContent">
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false"></loading-screen>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          Edit Delivery Location
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <form [formGroup]="addressFormGroup" autocomplete="off" id="editAddressForm">
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput type="text" class="companyName" formControlName="companyName" placeholder="COMPANY NAME"
                aria-describedby="helpId" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput type="text" class="attnRef" formControlName="attnOrRef" placeholder="ATTN/REF" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine1" type="text" class="addressLine1" formControlName="addressLine1"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 1" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine2"  type="text" class="addressLine2" formControlName="addressLine2"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 2">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine3" type="text" class="addressLine3" formControlName="addressLine3"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 3">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <!-- (keyup)="startFilterSub()" -->
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="suburb"  (input)="onInputSub($event)"  (suburb)="startFilterSub($event)"
                #myAutocompleteTriggerSub="matAutocompleteTrigger" [matAutocomplete]="autoSuburb"
                formControlName="suburb" placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)"
               required>
              <mat-autocomplete #autoSuburb="matAutocomplete">
                <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ng-select class="customDropdwon state" [items]="stateList" bindValue="state"
              bindLabel="state" placeholder="STATE *" formControlName="state"></ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <!-- (keyup)="startFilterPostcode()" -->
              <input matInput class="postCode" maxlength="4"  (postcode)="startFilterPostcode($event)"
                #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
                (keypress)="isNumberKey($event)" formControlName="postcode" 
                (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode" placeholder="POST CODE"
                required>
              <mat-autocomplete #autoPostcode="matAutocomplete">
                <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="phone" formControlName="phone" placeholder="PHONE" required>
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class="col-md-12 align-center">
            <button id="buttonSave" type="button" class="button button-red button-large"
              (click)="saveAddressToAccount()">Save</button>
          </div>
          <div class="col-md-12 align-center">
            <p id="deleteButton"><a id="buttonDelete" class="deleteBtn" (click)="deleteAddress()">Delete</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>